import React from "react";
import { css } from "glamor";
import { FaDollarSign, FaCalendar, FaCheckCircle } from "react-icons/fa";
import Spinner from "../library/Spinner";
import Page from "../library/Page";
import Card from "../library/Card";
import { colors, spacing } from "../library/theme";
import { toBRLCurrency } from "../../utils/formatCurrency";
import ProductPurchasesContainer from "./ProductPurchasesContainer";
import { formatDate, isFuture } from "../../utils/dateUtils";

const cardsGrid = css({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
  gap: spacing.m,
  marginBottom: spacing.m,
  "> .ui.card": {
    margin: "0px !important",
    marginBottom: spacing.m,
  }
});

const cardLabel = css({
  fontSize: 11,
  color: colors.greyDark,
  marginBottom: spacing.s,
  display: 'flex',
  alignItems: 'center',
  gap: spacing.xs,
  fontWeight: '500',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
});

const cardValue = css({
  fontSize: 22,
  fontWeight: '700',
  color: colors.black,
  lineHeight: 1.2,
});

const statusCardValue = css(cardValue, {
  display: 'flex',
  alignItems: 'center',
  gap: spacing.xs,
});

export default function Product({ product, loading }) {
  if (loading) {
    return <Spinner text="Carregando..." />;
  }

  return product ? (
    <Page title={product.name}>
      <div className={cardsGrid}>
        <Card fluid>
          <Card.Content>
            <span className={cardLabel}>
              <FaDollarSign /> Preço
            </span>
            <div className={cardValue}>
              {toBRLCurrency(product.latestPurchasedPrice)}
            </div>
          </Card.Content>
        </Card>

        <Card fluid>
          <Card.Content>
            <span className={cardLabel}>
              <FaCheckCircle /> Acesso
            </span>
            <div className={css(statusCardValue, { color: isFuture(product.latestCoursesUserExpiresAt) ? "green" : "red" })}>
              {isFuture(product.latestCoursesUserExpiresAt) ? "Com acesso" : "Acesso expirado"}
            </div>
          </Card.Content>
        </Card>

        <Card fluid>
          <Card.Content>
            <span className={cardLabel}>
              <FaCalendar /> Data de Expiração do Acesso
            </span>
            <div className={cardValue}>
              {formatDate(product.latestCoursesUserExpiresAt)}
            </div>
          </Card.Content>
        </Card>
      </div>

      <ProductPurchasesContainer productId={product.id} />
    </Page>
  ) : null;
}
